interface NotificationParams {
  id: string;
  topic: string;
  type: string;
  read?: boolean;
  metadata: Record<string, any>;
  timestamp: Date;
  eventName: string;
}

export class Notification {
  private id: string;

  private topic: string;

  private type: string;

  private read: boolean;

  private metadata: Record<string, any>;

  private timestamp: Date;

  private eventName: string;

  constructor(params: NotificationParams) {
    const { id, topic, type, read = false, metadata, timestamp, eventName } = params;

    this.id = id;
    this.topic = topic;
    this.type = type;
    this.read = read;
    this.metadata = metadata;
    this.timestamp = timestamp;
    this.eventName = eventName;
  }

  getId(): string {
    return this.id;
  }

  getMetadata(): Record<string, any> {
    return this.metadata;
  }

  getTimestamp(): Date {
    return this.timestamp;
  }

  getTopic() {
    return this.topic;
  }

  getType(): string {
    return this.type;
  }

  getEventName() {
    return this.eventName;
  }

  isRead(): boolean {
    return this.read;
  }

  markAsRead(): void {
    this.read = true;
  }
}
